import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";
import { Button } from "components/UI";
import { DateField } from "components/UI/InputFields/DateField";
import { useChurchStore } from "features/churches";
import { useSchedulePaymentRequisition } from "features/finances";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const SchedulePaymentModal = ({ open, onClose, requisition }) => {
  const [date, setDate] = useState(new Date());

  const selectedChurch = useChurchStore(state => state.selectedChurch);

  const schedulePaymentMutation = useSchedulePaymentRequisition();
  const navigate = useNavigate();

  const handleSchedulePayment = () => {
    schedulePaymentMutation.mutate(
      {
        churchId: selectedChurch?.id,
        requisitionId: requisition?.id,
        requisitionData: {
          schedule_at: date.toISOString()
        }
      },
      {
        onSuccess: () => {
          onClose();
          navigate(`/finances/temp/expense/requisition`);
        }
      }
    );
  };

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <DialogTitle>
        <Typography component="span" variant="subtitle2">
          Schedule Payment
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DateField
          hasNoBg
          disablePastDates
          value={date}
          onChange={e => setDate(e)}
          label="Date"
        />
      </DialogContent>
      <DialogActions>
        <Button
          flavor="text"
          onClick={onClose}
          disabled={schedulePaymentMutation.isLoading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSchedulePayment}
          disabled={schedulePaymentMutation.isLoading}
        >
          Schedule
        </Button>
      </DialogActions>
    </Dialog>
  );
};
